module.exports = __webpack_public_path__ + "img/advantage_2.140621f4.png";